export default {
      id: "i-file-pie-usage",
      viewBox: "0 0 37 37",
      url: __webpack_public_path__ + "img/sprite.svg#i-file-pie",
      toString: function () {
        return this.url;
      }
    }